export const whiteAlpha = {
  whiteA0: 'rgba(245, 245, 245, 0)',
  whiteA1: 'rgba(245, 245, 245, 0.1)',
  whiteA2: 'rgba(245, 245, 245, 0.2)',
  whiteA3: 'rgba(245, 245, 245, 0.3)',
  whiteA4: 'rgba(245, 245, 245, 0.40)',
  whiteA5: 'rgba(245, 245, 245, 0.44)',
  whiteA6: 'rgba(245, 245, 245, 0.58)', // glass effect
  whiteA7: 'rgba(245, 245, 245, 0.62)',
  whiteA8: 'rgba(245, 245, 245, 0.66)',
  whiteA9: 'rgba(245, 245, 245, 0.7)',
  whiteA10: 'rgba(245, 245, 245, 0.74)',
  whiteA11: 'rgba(245, 245, 245, 0.78)',
  whiteA12: 'rgba(245, 245, 245, 0.96)',
};
